export default __webpack_public_path__ + "static/media/Landing icon.c889f88f.svg";